import React from "react";
import { Card } from "react-bootstrap";

const Recap = ({ state }) => {
    return (
        <Card className="mb-3">
            <Card.Body>
                <h4>Dit heb je ingevuld:</h4>
                <ul>
                    <li>Land van: {state.countryFrom}</li>
                    <li>Land naar: {state.countryTo}</li>
                    {state.USState && <li>Staat: {state.USState}</li>}
                    <li>Incoterm: {state.incoterm}</li>
                    <li>Waarde: {state.EUR1 ? "€6000+" : "<€6000"}</li>
                    <li>Geschenk: {state.gift ? "Ja" : "Nee"}</li>
                </ul>
            </Card.Body>
        </Card>
    );
};

export default Recap;
